import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { DailySchedule } from '../../models/settings/daily-schedule.model';
import { ScheduleCreate } from '../../models/settings/daily-schedule-create';
import { DailyScheduleTime } from '../../models/settings/daily-schedule-time.model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient, private httpHelper: HttpHelperService) { }

  /**
   * This function used to create open hours.
   * @param data object
   * @returns
   */
  createOpenHours(data: object): Observable<ScheduleCreate> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/OpenHours/CreateOpenHours`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post<ScheduleCreate>(apiUrl, data, requestOptions);
  }

  /**
   * This function is used to update recurring open hours.
   * @param data object
   * @returns
   */
  updateOpenHours(data: object): Observable<ScheduleCreate> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/OpenHours/UpdateOpenHours`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<ScheduleCreate>(apiUrl, data, requestOptions);
  }

  /**
   * This function is used to get recurring open hours.
   * @param stylistId number
   * @param dayId number
   * @returns
   */
  getOpenHoursById(data:DailySchedule): Observable<DailySchedule[]> {
    let params = new HttpParams()
      .set('StylistId', data.stylistId)
      .set('DayId', data.dayId)
      .set('Date', data.date)
    const apiUrl = this.httpHelper.getApiUrl(`/api/OpenHours/GetOpenHoursById`);
    return this.http.get<DailySchedule[]>(apiUrl, { params: params });
  }

  /**
   * This function is used to delete the open hour time slot.
   * @param data object
   * @returns 
   */
  cancelOpenHours(data: DailyScheduleTime): Observable<DailyScheduleTime> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/OpenHours/CancelOpenHours`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put(apiUrl, data, requestOptions);
  }

  downloadQrPoster(paramsReq): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`api/Stylists/DownloadQRCodeTemplate?stylistId=${paramsReq.stylistId}&isDarkModeTemplate=${paramsReq.isDarkModeTemplate}`);
    
    const requestOptions: Object = {
      responseType: 'blob' // Change from 'text' to 'blob'
    };
    
    return this.http.post(apiUrl, paramsReq, requestOptions);
  }


}
